export default "__VITE_ASSET__BTBOhO0G__"